import SessionPrepView from "@/pages/RehearsalRoom/client360/SessionPrepView";
import { useTeamSessions } from "@/lib/teamRecordQueries";

/**
 * Clients Restructure — Team 360 -> Prep. Reuses the EXACT same
 * SessionPrepView as Client 360's own Prep tab — with no `memberId`,
 * it derives its "Team"/each-client/"Coach" audience tabs straight
 * from the real Session's own participant_member_ids (2+ clients),
 * never a separate preparation engine.
 */
export default function PrepTab({ workspaceId }) {
  const { data, isPending } = useTeamSessions(workspaceId);
  const upcoming = (data?.items || []).filter((s) => ["booked", "join_window", "live"].includes(s.room_state));
  const nextSession = upcoming.sort((a, b) => new Date(a.starts_at) - new Date(b.starts_at))[0];

  if (isPending) return <p className="text-sm text-ink-soft" data-testid="team-prep-loading">Loading…</p>;

  if (!nextSession) {
    return (
      <p className="text-sm text-ink-soft" data-testid="team-prep-empty">
        No upcoming team session yet — book one from the Sessions tab, then prepare it here.
      </p>
    );
  }

  return (
    <div data-testid="team-360-prep-tab">
      <SessionPrepView key={nextSession.ses_id} workspaceId={workspaceId} sesId={nextSession.ses_id} />
    </div>
  );
}
